import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import classnames from 'classnames';

import { PlaylistItem } from './playlist-item';

import './playlist.scss';

export class Playlist extends Component {
  static propTypes = {
    videos: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
        description: PropTypes.string,
        thumbnailUrl: PropTypes.string,
      })
    ),
    selectVideo: PropTypes.func.isRequired,
  };

  static defaultProps = {
    videos: [],
  };

  state = {
    showPlaylist: false,
  };

  togglePlaylist = () => {
    this.setState({ showPlaylist: !this.state.showPlaylist });
  };

  initSelectedVideo = (e, selectedVideo) => {
    e.preventDefault();
    this.props.selectVideo(selectedVideo);
    this.togglePlaylist();
  };

  render() {
    const videos = this.props.videos;

    if (!(videos && videos.length)) return null;

    const { showPlaylist } = this.state;
    return (
      <div className={classnames('playlist h-100', { 'playlist-opened': showPlaylist })}>
        <Button className="playlist-toggle-btn border-0 text-uppercase text-white" onClick={this.togglePlaylist}>
          {showPlaylist ? 'less...' : 'more...'}
        </Button>
        <div className="playlist-container pt-0_5 px-0_5 h-100 w-100">
          {showPlaylist &&
            videos.map(video => (
              <PlaylistItem initSelectedVideo={this.initSelectedVideo} videoMeta={video} key={video.thumbnailUrl} />
            ))}
        </div>
      </div>
    );
  }
}
